import { useTranslations } from '@vocab/react';
import { Box, Divider, Stack, Accordion } from 'braid-design-system';

import CategoryGroupCard from 'src/components/atoms/CategoryGroupCard/CategoryGroupCard';
import CreateThreadCard from 'src/components/molecules/Shared/CreateThreadCard/CreateThreadCard';
import { getPagePaths } from 'src/core/domain/pages';
import { useAnalytics } from 'src/provider/analytics';
import { useConfig } from 'src/provider/config';
import { usePage } from 'src/provider/page';

import translations from './.vocab';
import MyGroups from './MyGroups';
import TopGroups from './TopGroups';

import * as styles from './Sidebar.css';

export function Sidebar() {
  const { t } = useTranslations(translations);
  const { trackAnalyticsInteraction } = useAnalytics();
  const { language } = useConfig();

  const {
    pageState: { pageName },
    pageDispatch,
  } = usePage();

  const featuredThreadCategory = t('featured-threads');
  const exploreGroupsCategory = t('explore-groups');

  const handleCreateThreadAnalytics = () => {
    trackAnalyticsInteraction('CreateThreadClick');
  };

  return (
    <Box data={{ testid: 'desktop-sidebar' }}>
      <a
        className={
          pageName === 'CommunityHome'
            ? styles.SelectedFeaturedThreadsSidebar
            : styles.FeaturedThreadsSidebar
        }
        key={featuredThreadCategory}
        href={getPagePaths({ language }).CommunityHome}
        onClick={() => {
          pageDispatch({ type: 'IS_LOADING' });
        }}
      >
        <CategoryGroupCard category={featuredThreadCategory} />
      </a>
      <a
        className={
          pageName === 'CommunityAllGroups'
            ? styles.SelectedSidebarExplorePage
            : styles.SidebarExplorePage
        }
        key={exploreGroupsCategory}
        href={
          getPagePaths({ language, queryParams: { type: 'all-groups' } })
            .CommunityGroups
        }
        onClick={() => {
          pageDispatch({ type: 'IS_LOADING' });
        }}
      >
        <CategoryGroupCard category={exploreGroupsCategory} />
      </a>
      <Stack space="small">
        <Divider />
        <CreateThreadCard
          handleCreateThreadAnalytics={handleCreateThreadAnalytics}
        />
      </Stack>
      <Box className={styles.AccordionItem}>
        <Accordion>
          <MyGroups />
          <TopGroups />
        </Accordion>
      </Box>
    </Box>
  );
}
